module.exports = __webpack_public_path__ + "static/Truck17-ad2014813f0f1efd52b7b1eada058f63.png";